// Supporting components
import '../ids-icon';
